function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDepartment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    x: 0,
    y: 0,
    viewBox: "0 0 395.701 395.701",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M257.164 185.503h12.347v12.347h-12.347zM191.612 293.075h12.347v12.347h-12.347zM126.125 185.503h12.347v12.347h-12.347z",
    style: {},
    fill: "#193651",
    "data-original": "#193651",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.818 157.64c25.988 0 48.808-12.994 62.448-33.358-13.576-19.782-36.461-32.776-62.448-32.776S149.01 104.5 135.37 124.282c13.64 20.429 36.46 33.358 62.448 33.358z",
    style: {},
    fill: "#fdbf5e",
    "data-original": "#fdbf5e",
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 197.818,
    cy: 55.046,
    r: 23.467,
    style: {},
    fill: "#fdbf5e",
    "data-original": "#fdbf5e",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.23 389.463c25.988 0 48.808-12.994 62.448-33.358-13.576-19.782-36.461-32.776-62.448-32.776s-48.808 12.994-62.448 32.776c12.994 20.428 35.879 33.358 62.448 33.358z",
    style: {},
    fill: "#f16051",
    "data-original": "#f16051"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82.23,
    cy: 286.869,
    r: 23.467,
    style: {},
    fill: "#f16051",
    "data-original": "#f16051"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.406 389.463c25.988 0 48.808-12.994 62.448-33.358-13.576-19.782-36.461-32.776-62.448-32.776-25.988 0-48.808 12.994-62.448 32.776 13.64 20.428 36.525 33.358 62.448 33.358z",
    style: {},
    fill: "#2ea2db",
    "data-original": "#2ea2db"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 313.406,
    cy: 286.869,
    r: 23.467,
    style: {},
    fill: "#2ea2db",
    "data-original": "#2ea2db"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.406 231.855c-21.657 0-40.792 8.663-55.661 21.657L203.96 222.61v-58.699c42.02-3.103 76.024-38.335 76.024-81.584.065-45.834-37.042-82.295-82.166-82.295s-82.23 36.461-82.23 82.23c0 43.248 33.358 78.481 76.024 81.584v58.699l-53.786 30.901c-14.804-13.576-34.004-21.657-55.661-21.657C36.461 231.855 0 268.315 0 313.438c0 45.77 36.461 82.23 82.23 82.23 45.123 0 82.23-36.461 82.23-82.23 0-19.135-6.788-36.461-17.907-50.683l51.911-29.673 51.911 29.673c-11.119 14.222-17.907 31.547-17.907 50.683 0 45.123 36.461 82.23 82.23 82.23 44.541 0 81.002-36.461 81.002-82.23-.064-45.123-36.524-81.583-82.294-81.583zM82.23 383.321c-38.917 0-69.883-30.901-69.883-69.883 0-38.335 30.901-69.883 69.883-69.883 38.335 0 69.883 30.901 69.883 69.883-.646 38.982-31.547 69.883-69.883 69.883zm45.705-301.058c0-38.917 31.547-69.883 69.883-69.883s69.883 30.901 69.883 69.883c0 38.335-30.901 69.883-69.883 69.883-38.335-.647-69.883-31.548-69.883-69.883zm185.471 301.058c-38.335 0-69.883-30.901-69.883-69.883 0-38.335 30.901-69.883 69.883-69.883 38.335 0 69.883 30.901 69.883 69.883s-30.901 69.883-69.883 69.883z",
    style: {},
    fill: "#193651",
    "data-original": "#193651",
    className: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDepartment);
export default __webpack_public_path__ + "static/media/department.383a32a6650c7aa7e213e06fb3ddd4ce.svg";
export { ForwardRef as ReactComponent };